<template>
  <div class="container-subtitle-settings">
    <AuxiliaryDisplayControlSubtitle v-model="subtitlePreference" type="local" />

    <div class="footer-subtitle-settings">
      <ButtonProcess full-width secondary @click="emit('close')">
        {{ t('close') }}
      </ButtonProcess>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, provide } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import AuxiliaryDisplayControlSubtitle from '@/components/domains/chat/chat-general/AuxiliaryDisplayControlSubtitle.vue';
import ButtonProcess from '@/components/shared/base/ButtonProcess.vue';
import { useChatPreferenceStore } from '@/stores/chatPreference';
import { useSocketStore } from '@/stores/socket';
import { ij_isModeSubtitle } from '@/utils/injectionKeys.js';

const emit = defineEmits<{ close: [] }>();

const { t } = useI18n();
const route = useRoute();

const socketStore = useSocketStore();
const chatPreferenceStore = useChatPreferenceStore();
const { subtitlePreference } = storeToRefs(chatPreferenceStore);

const isSubtitleMode = computed<boolean>(() => {
  const isMetaSubtitle = route.meta.chatType === 'SUBTITLE';
  const isConnectionSubtitle = socketStore.connectInfo?.connectionType === 'SUBTITLE';
  return isMetaSubtitle || isConnectionSubtitle;
});

provide(ij_isModeSubtitle, isSubtitleMode);
</script>

<style scoped lang="scss">
.container-subtitle-settings {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: var(--surface-default);
  padding: 1rem 1rem 0 1rem;
  margin: 1rem;
  border-radius: 16px;
  width: calc(100dvw - 2rem);
  gap: 1rem;
  box-shadow: $shadow-modal;
  z-index: 1;

  @include respond-to(mobile-landscape) {
    height: 100%;
    max-height: 30rem;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.footer-subtitle-settings {
  position: sticky;
  bottom: 0;
  display: flex;
  width: 100%;
  gap: 0.5rem;
  margin-top: auto;
  padding-bottom: 1rem;
  background-color: var(--surface-default);
}

.button-icon {
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
